import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Subjects($page: Int, $perPage: Int, $search: String) {
    Subjects(page: $page, perPage: $perPage, search: $search) {
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
      items {
        name
        id
        position
        group
        hours
        ref
      }
    }
  }
`);

export interface GetAllItem {
  group: string;
  name: string;
  position: number;
  id: number;
  hours?: number;
  ref?: string;
}

export interface GetAllGql {
  Subjects: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
